import { Component,Input, OnInit, Output ,OnChanges,SimpleChanges} from '@angular/core';
import { Location } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { Router, NavigationExtras } from '@angular/router';
import { ConfirmacionesService} from '../../../services/confirmaciones.service';
import { PagosService} from '../../../services/pagos-service.service';
import { CatalogosService } from '../../../services/catalogos.service';
import { ClientesService } from '../../../services/clientes.service';
import { UsuariosPersonalService } from 'app/services/usuarios-personal.service';


@Component({
    selector: 'registrar-pago',
    templateUrl: './registrar-pago.component.html'
})

export class RegistrarPagoComponent implements OnInit {

    @Input() idConfirmacion: any; //[idConfirmacion]="objeto.propiedad"
    @Input() cliente:Observable<any>;
    @Input() servicios:Observable<any>;
    @Input() resultadoLista: any;

    pagosConfirmacion:any=[]
    pagoRegistro:any={};
    pago:any={};
    confirmacion:any={}
    confirmacionId:any;
    idPagoActulizar:any;

     // Catálogos para pagos
    formasDePago: Observable<any>;
    procesosDePago: Observable<any>;
    // Imagen Comprobante
    imagenComprobante:File;
    nombreComprobante:any='Subir Comprobante';

    imagenIdOficial:File;
    nombreIdOficial:any='Subir ID Oficial';

    esEditar:boolean=false;
    saldoAFavor:any;
    loaderMsg = "Cargando...";
    showLoader = false;
    currentUser:any;
    constructor(
        public route:Router,
        private pagosService:PagosService,
        private confirmacionesService : ConfirmacionesService,
        private catalogosService: CatalogosService,
        private ClientesService:ClientesService,
        private usuariosPersonalService:UsuariosPersonalService
    ){
        this.pagoRegistro = {
            factura: false,
            iva:0,
            monto:0,
            procesoDePago:'',
            prioridad: 'Normal',
        };
    }

    // Función de OnInit
    ngOnInit(){
         this.currentUser = this.usuariosPersonalService.auth;
        this.formasDePago = this.catalogosService.obtenerFormasDePago().valueChanges().take(1);
        this.procesosDePago = this.catalogosService.obtenerProcesosDePago().valueChanges().take(1);
        this.confirmacionesService.obtenerConfirmacion(this.idConfirmacion).valueChanges().take(1).subscribe(confirmacionDB =>{
            this.confirmacion = confirmacionDB

            this.ClientesService.obtenerPropiedadCliente(this.confirmacion.cliente, 'procesoDePago').valueChanges().take(1).subscribe(res=>{
                this.pagoRegistro.procesoDePago=res;
            })
            this.ClientesService.obtenerPropiedadCliente(this.confirmacion.cliente, 'saldoAFavor').valueChanges().take(1).subscribe(res=>{
                this.saldoAFavor=res;
            })
        });

    }
    verificarSaldo(){
        if(this.pagoRegistro.formaDePago == 'Saldo a Favor'){
            if(this.pagoRegistro.total > this.saldoAFavor){
                alert('El total no puede superar el Saldo a favor')
                    this.pagoRegistro.total=0;
            }
        }
        this.calcularDesgloseIVA();
    }
    ngOnChanges(changes: SimpleChanges) {
        for (let propName in changes) {
            let change = changes[propName];
            try{
                let curVal  = change.currentValue == undefined ? "{}": JSON.stringify(change.currentValue);
                let prevVal = change.previousValue == undefined ? "{}": JSON.stringify(change.previousValue);
                let objeto= JSON.parse(curVal)
                if(objeto.esEditar){
                    let fechaString= new Date(objeto.fechaProgramada).toISOString().slice(0,10);
                    this.pagoRegistro={
                        confirmacion:objeto.confirmacion,
                        confirmacionIdTrosten:objeto.confirmacionIdTrosten,
                        procesoDePago:objeto.procesoDePago,
                        keyPago:objeto.$key,
                        total: objeto.total,
                        formaDePago:objeto.formaDePago,
                        fechaDePago:fechaString,
                        prioridad: objeto.prioridad,
                    }
                    this.esEditar=true;
                    this.calcularDesgloseIVA();
                }else{
                    this.esEditar=false
                    this.limpiarFormulario()
                }
            }catch(Exception){}
        }
     }
     crearPagoRegistrado(){
         this.verificarSaldo()
         this.calcularDesgloseIVA()
         this.showLoader = true

        let keyPago;
        if(this.esEditar){
            if(!this.imagenComprobante){
               this.pagosService.actualziarPago(this.pagoRegistro, this.pagoRegistro.keyPago).then(res=>{
                this.limpiarFormulario();
                this.showLoader = false
               })

            }
            else{
                this.verificarQueNoSaNull()
                this.pagosService.subirComprobante(this.pagoRegistro.keyPago, this.imagenComprobante).then(imagenComprobante =>{
                this.pagoRegistro.imagenComprobante=imagenComprobante.downloadURL;
                this.pagosService.actualziarPago(this.pagoRegistro, this.pagoRegistro.keyPago).then(res=>{
                    this.limpiarFormulario();
                    this.showLoader = false
                   })

                })
            }
        }else{
            this.verificarQueNoSaNull()
            this.pagosService.generarKeyPago().then((key)=>{
                console.log("key",key)
                keyPago= key.id
                console.log(keyPago)
                if(!this.imagenComprobante){
                    this.showLoader = false
                    alert("Debes subir un comprobante de pago, el área de finanzas requiere estos comprobantes para el control de los pagos.")
                }else{
                    this.pagosService.subirComprobante(keyPago, this.imagenComprobante).then(imagenComprobante =>{
                        this.pagoRegistro.imagenComprobante=imagenComprobante.downloadURL;
                        this.pagoRegistro.idTrosten = this.confirmacion.idTrosten;
                        this.pagoRegistro.confirmacionId= this.idConfirmacion;
                        this.pagoRegistro.usuarioCreador  = this.currentUser.uid;
                        this.pagosService.insertarPagoRegistrado(this.pagoRegistro, keyPago,this.confirmacion.cliente,this.saldoAFavor,this.currentUser.uid)
                        //this.pagosService.actualizarMontoPagado(this.pagoRegistro.total + this.confirmacion.montoPagado,this.idConfirmacion)

                        this.limpiarFormulario()
                        this.ClientesService.obtenerPropiedadCliente(this.confirmacion.cliente, 'saldoAFavor').valueChanges().take(1).subscribe(res=>{
                            this.saldoAFavor=res;
                            this.showLoader = false
                        })
                    })
                }
            })
        }
    };
    asignarImagenComprobante(event){
        let archivo:File = event.target.files[0];
        this.imagenComprobante = archivo;
        this.nombreComprobante= archivo.name
    }

    asignarImagenIdOficial(event){
        let archivo:File = event.target.files[0];
        this.imagenIdOficial = archivo;
        this.nombreIdOficial= archivo.name
    }
    limpiarFormulario(){
        this.pagoRegistro = {
            iva:0,
            procesoDePago:'',
            prioridad: 'Normal',
            total:0,
            monto:0};
        this.imagenComprobante=undefined;
        this.nombreComprobante= 'Subir Comprobante';
        this.imagenIdOficial=undefined;
        this.nombreIdOficial= 'Subir ID Oficial';
    }

    verificarFecha(fecha ){
        this.verificarQueNoSaNull()
        if(this.pagosConfirmacion.length == 0){
            if(this.pagoRegistro.procesoDePago == 'Proceso'){
                console.log('')
            }else{
                this.servicios.subscribe((servicio)=>{
                let fechaArreglo=fecha.split('-');
                let fechaNueva= new Date(Number(fechaArreglo[0]),Number(fechaArreglo[1]-1),Number(fechaArreglo[2])).getTime();
                let alerta= false
                servicio.forEach(servicioFor => {
                        if(fechaNueva > servicioFor.inicioDeServicio){
                            alerta=true;
                            this.pago.fechaProgramada=''
                            this.pagoRegistro.fechaProgramada='';
                        }
                    });
                if(alerta)
                alert('La fecha debe ser menor')
                })
            }
        }
    }
    calcularDesgloseIVA(){
        if (this.confirmacion && this.confirmacion.requiereFactura && this.pagoRegistro.total > 0) {
            this.pagoRegistro.subtotal = Math.round((this.pagoRegistro.total / 1.16) * 100) / 100;
            this.pagoRegistro.iva = Math.round((this.pagoRegistro.total - this.pagoRegistro.subtotal) * 100) / 100;
        } else {
            this.pagoRegistro.subtotal = 0;
            this.pagoRegistro.iva = 0;
        }
    }

    verificarQueNoSaNull(){
        if(this.pagoRegistro.total ==null)
            this.pagoRegistro.total =0
        if(this.pagoRegistro.total < 0)
            this.pagoRegistro.total =0
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/registrar-pago/registrar-pago.component.ts